import { render, staticRenderFns } from "./AboutHonor.vue?vue&type=template&id=8230d5e4&scoped=true&"
import script from "./AboutHonor.vue?vue&type=script&lang=js&"
export * from "./AboutHonor.vue?vue&type=script&lang=js&"
import style0 from "./AboutHonor.vue?vue&type=style&index=0&id=8230d5e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8230d5e4",
  null
  
)

export default component.exports